<aside class="legend-panel" [attr.aria-label]="'Map.Legend.Title' | translate">
  <div class="legend-panel__header">
    <h2 class="legend-panel__title dv-headline-lg">{{ 'Map.Legend.Title' | translate }}</h2>
    <dv-button
      size="md"
      color="basic"
      icon="close"
      [tooltip]="'Button.Close' | translate"
      (click)="closed.emit()"
    ></dv-button>
  </div>

  <div class="legend-panel__segments">
    <dv-segmented-button
      [items]="viewItems()"
      [(value)]="selectedView"
      [isFullWidth]="true"
      [ariaLabel]="'Map.Legend.Title' | translate"
    />
  </div>

  <dv-divider padding="4px" />

  <div class="legend-panel__content dv-body-md">
    @if (selectedView() === 'trails') {
      <h3 class="legend-panel__group-title dv-label-md">
        {{ 'Map.Legend.LastGroomed' | translate }}
      </h3>
      <ul class="legend-panel__list">
        @for (level of lastGroomedLevels; track level.textKey) {
          <li class="legend-panel__item">
            <img [src]="level.iconUrl" width="24" height="24" alt="" />
            {{ level.textKey | translate }}
          </li>
        }
      </ul>

      <h3 class="legend-panel__group-title dv-label-md">
        {{ 'Map.Legend.TrailTypes' | translate }}
      </h3>
      <ul class="legend-panel__list">
        <li class="legend-panel__item">
          <svg
            class="legend-panel__trail-sample"
            width="48"
            height="24"
            viewBox="0 0 48 24"
            aria-hidden="true"
          >
            <path d="M2 12H46" stroke="currentColor" stroke-width="4" stroke-linecap="round" />
          </svg>
          {{ 'Map.Legend.SkiTrail' | translate }}
        </li>
        <li class="legend-panel__item">
          <svg
            class="legend-panel__trail-sample"
            width="48"
            height="24"
            viewBox="0 0 48 24"
            aria-hidden="true"
          >
            <path d="M2 12H46" stroke="white" stroke-width="6" stroke-linecap="round" />
            <path
              d="M2 12H7.2381M46 12H40.7619M11.4286 12H21.9048M26.0952 12H36.5714"
              stroke="currentColor"
              stroke-width="4"
            />
            <circle
              cx="24"
              cy="12"
              r="9.25"
              fill="white"
              [attr.stroke]="walkingMarkerBorderColor"
              stroke-width="1.5"
            />
            <!-- viewBox pads the tight footprint glyph the same way as the 24px Material icon -->
            <svg x="17" y="5" width="14" height="14" viewBox="-1.1667 -0.5833 14 14">
              <path [attr.d]="FootprintIconPath" fill="currentColor" />
            </svg>
          </svg>
          {{ 'Map.Legend.WalkingTrail' | translate }}
        </li>
      </ul>
    } @else {
      <div class="legend-panel__switch-row legend-panel__switch-row--show-all">
        <label class="legend-panel__switch-label" for="legend-poi-show-all">
          <span class="dv-label-lg">{{ 'Map.Legend.ShowAll' | translate }}</span>
          <span class="legend-panel__count dv-body-sm">
            {{ shownPoiTypesCount() + '/' + poiTypesCount() }}
          </span>
        </label>
        <dv-toggle
          [id]="'legend-poi-show-all'"
          [checked]="isAllPoiTypesShown()"
          (checkedChange)="setAllPoiTypesShown($event)"
        />
      </div>

      @for (group of poiGroups(); track group.group) {
        <div class="legend-panel__switch-row">
          <label
            class="legend-panel__group-title legend-panel__group-title--switch dv-label-md"
            [for]="'legend-poi-group-' + group.group"
          >
            {{ group.titleKey | translate }}
          </label>
          <dv-toggle
            [id]="'legend-poi-group-' + group.group"
            [checked]="group.isAllShown"
            (checkedChange)="setPoiGroupShown(group, $event)"
          />
        </div>
        <ul class="legend-panel__list">
          @for (type of group.types; track type.key) {
            <li class="legend-panel__item legend-panel__switch-row">
              <span
                class="legend-panel__poi-icon"
                [class.legend-panel__poi-icon--off]="!type.isShown"
                [innerHTML]="type.iconHtml"
              ></span>
              <label class="legend-panel__switch-label" [for]="'legend-poi-type-' + type.key">
                {{ type.name }}
              </label>
              <dv-toggle
                [id]="'legend-poi-type-' + type.key"
                [checked]="type.isShown"
                (checkedChange)="setPoiTypeShown(type.key, $event)"
              />
            </li>
          }
        </ul>
      }
    }
  </div>
</aside>
